import { Box, Typography } from "@mui/material";
import SubAreaCard from "../../forms/subAreaForm/subAreaCard.component";

const SubAreasTabPanel = ({ field, theme }) => {
  const subAreas = field.field_parts;
  const position = field?.polygon;
  return (
    <Box
      width="100%"
      height="100%"
      py={2}
      display="flex"
      flexDirection="column"
      gap={2}
      alignItems="center"
      sx={{
        overflowY: "auto",
      }}
    >
      {subAreas.length > 0 ? (
        subAreas.map((subArea) => (
          <SubAreaCard
            key={subArea.id}
            theme={theme}
            savedData={subArea}
            editable={false}
            fieldPosition={position}
          />
        ))
      ) : (
        <Typography fontSize="14px">
          Non sono stati inseriti sottoterreni
        </Typography>
      )}
    </Box>
  );
};

export default SubAreasTabPanel;
